import(/* webpackMode: "eager" */ "/home/cwd/frontend_projects/cwd-website/node_modules/@iconify/react/dist/iconify.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/cwd/frontend_projects/cwd-website/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/cwd/frontend_projects/cwd-website/src/components/Products/Detail/ProductAccessories.tsx");
;
import(/* webpackMode: "eager" */ "/home/cwd/frontend_projects/cwd-website/src/components/Products/Detail/ProductDetailHero.tsx");
;
import(/* webpackMode: "eager" */ "/home/cwd/frontend_projects/cwd-website/src/components/Products/Detail/ProductTabs.tsx");
